// extracted by mini-css-extract-plugin
module.exports = {"tile":"tile_tile__wbD_2","actionButtonContainer":"tile_actionButtonContainer___Cr7S","rotate-animation":"tile_rotate-animation__K7_f7"};